import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Router, CanActivate, CanActivateChild } from '@angular/router';
import { AuthService } from '@examsoft/es-login';
import { StorageService, LOCAL_STORAGE } from 'angular-webstorage-service';
import { Inject } from '@angular/core';
import { EulaService } from '../eula.service';
import { first, map, concatMap } from 'rxjs/operators';


@Injectable()
export class AuthGuardService implements CanActivateChild, CanActivate {

  constructor(
    @Inject(LOCAL_STORAGE) private storage: StorageService,
    public authService: AuthService,
    public router: Router,
    private eulaService: EulaService,
  ) { }

  private guard(next, state) {
    return this.authService.guard(next, state)
      .pipe(
        concatMap((): any => this.eulaService.hasAcceptedLatest(this.authService.user['custom:es-id']).pipe(first())),
        map((data: any) => {
          if (!data.hasUserAcceptedLatest) {
            this.router.navigateByUrl('/eula');
            return true;
          }
          return true;
        }),
      );
  }

  canActivate(next, state): Observable<boolean> {
    return this.guard(next, state);
  }

  canActivateChild(next, state): Observable<boolean> {
    return this.guard(next, state);
  }

}
